<template>
  <div class="row book w-100">
    <!-- <canvas id="widget-1" style="width: 100%"></canvas> -->
    <iframe src="/lectura2ObsequioIdeal/index.html" frameborder="0" width="100%" height="100%" style="border: none"></iframe>
  </div>
</template>
<script>
import Auth from '@/services/Auth';
import NProgress from 'nprogress';

export default {
  name: 'activity3',
  async created() {
    NProgress.done();
  },
  computed: {
    missionId () {
      return this.$route.params.missionId;
    }
  },
  methods: {
    logout() {
      Auth.logout();
    },
    goToMission() {
      this.$router.push(`/mission/${this.missionId}`);
    }
  },
}
</script>
<style lang="scss">

.spacecraft-container-glass {
  min-width: 100%;
  min-height: 100vh;
  max-height: 100vh;
  padding-top: 1rem !important;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraft.png');
  background-size: cover;
  display: flex;
  align-items: center;
}

.mission-screen {
  border-style: solid;
  border-color: #17202A;
  border-width: 20px;
  border-radius: 50px;
  min-width: 93%;
  min-height: 95vh;
  margin: auto;
  padding-top: 0;
  padding-bottom: 0rem;
  padding-left: 2rem;
  background-image: url('/img/glass.png');
  background-size: cover;
}

.book {
  min-height: 80vh;
}
</style>